<template>
  <v-app>
    <div class="fixed-top mybg">
      <div class="mycontainer header-top">
        <v-card-title style="margin:0px;padding:0px">
            <span class="res" style="margin:0"
              ><v-icon color="black" small>call</v-icon>&nbsp;033-2674-0229 / 9748522255 / 9830953953&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<v-icon color="black" small>email</v-icon
              >&nbsp;majumderspecial@gmail.com / salesinfoms@gmail.com</span
            >
            <span class="man" style="margin:0"
              ><v-icon color="white" small>call</v-icon>&nbsp;033-2674-0229 / 9748522255 / 9830953953&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <br /><v-icon color="black" small
                >email</v-icon
              >&nbsp;majumderspecial@gmail.com / salesinfoms@gmail.com</span
            >

            <v-spacer></v-spacer><v-spacer></v-spacer>
            <a href="https://www.facebook.com/profile.php?id=100064500534586&mibextid=kFxxJD" target="_blank"><img src="../../assets/icons/facebook.png" /></a>
            <a href="https://www.instagram.com/debanjan.majumder/?igsh=MWFzNnpmcWM5eXQ3NA%3D%3D" target="_blank"><img src="../../assets/icons/instagram.png" /></a>
            <a href="#"><img src="../../assets/icons/youtube.png" /></a>
          </v-card-title>
      </div>
      <div class="mycontainer">
        <b-navbar toggleable="lg" style="height:70px;">
        <b-navbar-brand class="res"
          ><img
            src="../../assets/logo.png"
            style="cursor: pointer;margin-top: 0px;height: 60px;"
            @click="main()"
        /></b-navbar-brand>
        <b-navbar-brand class="man"
          ><img
            src="../../assets/logo.png"
            class="img-responsive"
            style="cursor: pointer; max-height: 50px;"
            @click="main()"
        /></b-navbar-brand>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="header-menu ml-auto txt_my">
            <b-nav-item class="txt_my" style="padding-top:10px ;" @click="setActiveItem('Home')"><span :style="{ color: activeItem === 'Home'? '#FF5555' : 'black' }">Home</span></b-nav-item>
            <b-nav-item class="txt_my" :class="{ active: activeItem === 'About us' }" style="padding-top:10px" @click="setActiveItem('About us')"><span :style="{ color: activeItem === 'About us'? '#FF5555' : 'black' }">About us</span></b-nav-item>
            <b-nav-item class="txt_my" :class="{ active: activeItem === 'Gallery' }" style="padding-top:10px" @click="setActiveItem('Services')"><span :style="{ color: activeItem === 'Services'? '#FF5555' : 'black' }">Our Services</span></b-nav-item>
            <b-nav-item class="txt_my" :class="{ active: activeItem === 'Gallery' }" style="padding-top:10px" @click="setActiveItem('Rules')"><span :style="{ color: activeItem === 'Rules'? '#FF5555' : 'black' }">Rules & Regulations</span></b-nav-item>
            <b-nav-item class="txt_my" :class="{ active: activeItem === 'Gallery' }" style="padding-top:10px" @click="setActiveItem('Gallery')"><span :style="{ color: activeItem === 'Gallery'? '#FF5555' : 'black' }">Gallery</span></b-nav-item>
            <b-nav-item-dropdown style="margin-top: 0px !important;" class="txt_my" text="Tour Packages" right>
              <b-dropdown-item :class="{ active: activeItem === 'Domestic' }" style="padding-top:10px" @click="setActiveItem('Domestic')"><span :style="{ color: activeItem === 'Domestic'? '#FF5555' : 'black' }">Domestic</span></b-dropdown-item>
              <b-dropdown-item class="txt_my" :class="{ active: activeItem === 'International' }" style="padding-top:10px" @click="setActiveItem('International')"><span :style="{ color: activeItem === 'International'? '#FF5555' : 'black' }">International</span></b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item style="margin-top:10px ;">
              <v-btn small @click.stop="enquiryDialog = true" style="border-radius: 20px !important;color: #f66f4d;" flat outline> 
                Tour Enquiry
              </v-btn>  
              <v-btn small @click.stop="bookDialog = true" style="border-radius: 20px !important;color: #f66f4d;" flat outline> 
                Book Now&nbsp;<v-icon :size="20">send</v-icon>
              </v-btn>        
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
        </b-navbar>
      </div>
    </div>

    <v-dialog v-model="enquiryDialog" max-width="600">
              <v-card style="border-radius:0px">
                <h4 style="text-align:center;padding-top:15px">Request Quote</h4>
                <v-divider></v-divider>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout row wrap style="padding:15px">
                    <v-flex xs12 sm12 md6 style="padding-right:5px">
                      <v-text-field
                        v-model="form.email"
                        append-icon="mark_email_read"
                        label="Email ID"
                        type="text"
                        :rules="[rules.emailid]"
                        required
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md6>
                      <v-text-field
                        v-model="form.mobileNumber"
                        append-icon="call"
                        label="Mobile number"
                        type="number"
                        min="0"
                        :rules="[rules.mobileno]"
                        required
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <v-text-field
                        v-model="form.destination"
                        label="Destination(s)"
                        :rules="[rules.required]"
                        required
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md6 style="padding-right:5px">
                      <v-text-field
                        v-model="form.startingFrom"
                        label="Starting From"
                        type="text"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md6>
                      <v-dialog
                        ref="dialog"
                        v-model="dateModel"
                        persistent
                        lazy
                        full-width
                        width="310px"
                      >
                        <v-text-field
                          append-icon="event"
                          slot="activator"
                          v-model="form.startDate"
                          label="Start Date"
                          readonly
                        ></v-text-field>
                        <v-date-picker v-model="form.startDate" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="dateModel = false">Ok</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>

                    <v-flex xs12 sm12 md6 style="padding-right:5px">
                      <v-autocomplete
                        v-model="selectedDuration"
                        :items="durations"
                        color="primary"
                        label="Trip Duration"
                        item-text="durations"
                        item-value="durations"
                        clearable
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm12 md6>
                      <v-text-field
                        v-model="form.budget"
                        label="Approximate Budget"
                        type="Number"
                        :rules="[rules.required]"
                        required
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md2 style="padding-right:5px">
                      <v-text-field
                        v-model="form.adult"
                        label="(Adults: 12+ Yrs)"
                        type="Number"
                        :rules="[rules.required]"
                        required
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md2 style="padding-right:5px">
                      <v-text-field
                        v-model="form.children"
                        label="(Child: 2-12 Yrs)"
                        type="Number"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md4 style="padding-right:5px">
                      <v-autocomplete
                        v-model="selectedTransportation"
                        :items="transportations"
                        color="primary"
                        label="Transportation"
                        item-text="transportations"
                        item-value="transportations"
                        clearable
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm12 md4>
                      <v-autocomplete
                        v-model="selectedAccommodation"
                        :items="accommodations"
                        color="primary"
                        label="Accommodation"
                        item-text="accommodations"
                        item-value="accommodations"
                        clearable
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12>
                      <v-textarea
                        :rows="3"
                        v-model="form.notes"
                        label="Notes / Special Requirements"
                      ></v-textarea>
                    </v-flex>

                    <v-flex xs12>
                      <b-form-checkbox v-model="form.need"
                        >Need transportation from my Starting City</b-form-checkbox
                      >
                    </v-flex>

                    <v-flex xs12 style="text-align:right">
                      <v-btn color="grey" dark @click.stop="enquiryDialog = false">Cancel</v-btn>
                      <v-btn :loading="btnSave" color="primary" dark @click="onSubmit()"
                        >Enquiry Now</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card>
            </v-dialog>

            <v-dialog v-model="bookDialog" max-width="100%">
              <v-card style="border-radius:0px">
                <h4 style="text-align:center;padding-top:15px">Book Now</h4>
                <v-divider></v-divider>

                <v-container>
                  <b-form-checkbox
                  size="lg"
                  id="checkbox-1"
                  v-model="bookForm.agree"
                  name="checkbox-1"
                >
                  <span style="font-size: 12px;">
                    I do hereby authorise
                    <span style="color: #034B93;font-size: 22px;font-weight: bold;"
                      >MAJUMDER SPECIAL</span
                    >, 275, criper road, Dist: Hooghly, Konnagar, Pin-712235,
                    to undertake all the necessary Job related to our package Tour from Howrah /
                    Sealdah
                  </span>
                </b-form-checkbox>

                <v-layout row wrap style="padding-top: 15px;">
                  <v-flex xs12 sm12 md6 style="padding-right: 5px;">
                    <b-form-input v-model="bookForm.tourName" placeholder="Tour Name *"></b-form-input>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <b-form-input v-model="bookForm.travelDate" placeholder="Travel Date *"></b-form-input>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <b-form-input v-model="bookForm.email" placeholder="Enter Your Email ID *"></b-form-input>
                  </v-flex>
                </v-layout>

                <v-layout row wrap style="padding-top: 15px;">
                  <v-flex xs12 sm12 md4 style="text-align: center;">
                    Name
                  </v-flex>
                  <v-flex xs12 sm12 md4 style="text-align: center;">
                    Sex
                  </v-flex>
                  <v-flex xs12 sm12 md4 style="text-align: center;">
                    Age
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-for="(item, index) of nameList" :key="index">
                  <v-flex xs12 sm12 md4 style="border: 1px solid;">
                    <b-form-input v-model="item.name" placeholder="Enter Name"></b-form-input>
                  </v-flex>
                  <v-flex xs12 sm12 md4 style="text-align: center;border: 1px solid;">
                    <b-form-radio-group
                    style="margin-top: 7px;"
                      v-model="item.sex"
                      :options="options"
                    ></b-form-radio-group>
                  </v-flex>
                  <v-flex xs12 sm12 md4 style="border: 1px solid;">
                    <b-form-input v-model="item.age" placeholder="Age"></b-form-input>
                  </v-flex>
                </v-layout>

                <v-btn flat color="primary" size="small" dark @click="onAdd()">Add More Member</v-btn>

                <v-layout row wrap style="padding-top: 15px;">
                  <v-flex xs12 md4 lg4>
                    <h5 style="margin-top: 7px;">Mode of Journey</h5>
                  </v-flex>
                  <v-flex xs12 sm12 md4 style="padding-right: 5px;">
                    <b-form-input v-model="bookForm.up" placeholder="UP"></b-form-input>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <b-form-input v-model="bookForm.dn" placeholder="DN"></b-form-input>
                  </v-flex>
                </v-layout>

                <v-layout row wrap style="padding-top: 15px;">
                  <v-flex xs12 md6 lg6 style="padding-right: 10px;">
                    <h5 style="margin-top: 7px;">Office</h5>
                    <b-form-input v-model="bookForm.officeAddress" placeholder="Address"></b-form-input><br/>
                    <b-form-input v-model="bookForm.officePhno" placeholder="Phone No."></b-form-input>
                  </v-flex>
                  <v-flex xs12 md6 lg6>
                    <h5 style="margin-top: 7px;">Residential</h5>
                    <b-form-input v-model="bookForm.residentialAddress" placeholder="Address"></b-form-input><br/>
                    <b-form-input v-model="bookForm.residentialPhno" placeholder="Phone No."></b-form-input>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs12 style="text-align:right">
                      <v-btn color="grey" dark @click.stop="bookDialog = false">Cancel</v-btn>
                      <v-btn v-if="bookForm.agree==true" :loading="btnSave" color="primary" dark @click="onBook()"
                        >SUBMIT</v-btn
                      >
                    </v-flex>
                </v-layout>
                </v-container>
              </v-card>
            </v-dialog>

    <v-content>
      <transition :name="transitionName" mode="out-in" @beforeLeave="beforeLeave" @enter="enter">
        <router-view></router-view>
      </transition>
    </v-content>

    <!-- ==================================================== FOOTER ================================================ -->

    <footer style="background-color:#FAF8ED">
      <div class="pt-5">
        <div class="container">
          <div class="row">
            <div class="col-sm-12 col-lg-4">
              <img
                src="../../assets/logo.png"
                style="cursor: pointer;margin-top: -10px;height: 70px;"
                @click="main()"
              />
              <div class="footer-info-box">
                <div class="">
                  <p>Customer Care</p>
                  <h4>033-2674-0229</h4>
                </div>
                <div class="">
                  <p>Need live support?</p>
                  <h4>majumderspecial@gmail.com</h4>
                </div>
              </div>
              <div class="footer-info-box">
                <h5>Follow us on social media</h5>
                <div class="h2 mb-0 socials">
                  <a href="https://www.facebook.com/people/Majumder-Special/100064500534586/?mibextid=kFxxJD" target="_blank"
                    ><div class="icon ">
                      <img
                        style="border-radius: 50%;padding: 10px;"
                        src="../../assets/icons/facebook.png"
                        alt=""
                      /></div
                  ></a>
                  <a href="https://www.instagram.com/debanjan.majumder/?igsh=MWFzNnpmcWM5eXQ3NA%3D%3D" target="_blank"
                    ><div class="icon ">
                      <img
                        style="border-radius: 50%;padding: 10px;"
                        src="../../assets/icons/instagram.png"
                        alt=""
                      /></div
                  ></a>
                  <a href="#" target="blank"
                    ><div class="icon ">
                      <img
                        style="border-radius: 50%;padding: 10px;"
                        src="../../assets/icons/youtube.png"
                        alt=""
                      /></div
                  ></a>
                </div>
              </div>
            </div>

            <div class="col-sm-12 col-lg-8">
              <!-- <h5 class="footer__header mb-4">DAILY OFFERS & DISCOUNTS</h5>
                            <nav class="d-inline-block">
                              <p class="d-block text-dark footer__link  footer__newsletter">Update your mail id with us to get regular offers and discounts</p>
                              <v-text-field
                               outline
                               v-model="UserName"
                             append-icon="mail"
                          name="login"
                          label="Mail us"
                          type="text"
                          ></v-text-field>
                            </nav>  -->
              <div class="row">
                <div class="col-sm-12 col-lg-3 mb-5 mb-lg-0">
                  <h5 class="footer__header mb-4" style="text-transform: uppercase;">
                    Navigations
                  </h5>
                  <nav class="d-inline-block">
                    <a
                      class="d-block text-dark footer__link footer__newsletter txt_dec"
                      @click="main()"
                      >Home</a
                    >
                    <a
                      class="d-block text-dark footer__link footer__newsletter txt_dec"
                      @click="aboutUs()"
                      >About us</a
                    >
                    <a
                      class="d-block text-dark footer__link  footer__newsletter txt_dec"
                      @click="packages()"
                      >Packages</a
                    >
                    <a
                      class="d-block text-dark footer__link  footer__newsletter txt_dec"
                      @click="gallery()"
                      >Gallery</a
                    >
                    <a
                      class="d-block text-dark footer__link  footer__newsletter txt_dec"
                      @click="contactus()"
                      >Contact</a
                    >
                    <a
                      href="#"
                      class="d-block text-dark footer__link  footer__newsletter"
                      @click="termsUse()"
                      >Rules & Regulations</a
                    >
                  </nav>
                </div>

                <div class="col-sm-12 col-lg-3 mb-5 mb-lg-0">
                  <h5 class="footer__header mb-4" style="text-transform: uppercase;">domestic</h5>
                  <nav class="d-inline-block">
                    <a @click="domestic()" class="d-block text-dark footer__link  footer__newsletter"
                      >Jammu & Kashmir</a
                    >
                    <a @click="domestic()" class="d-block text-dark footer__link  footer__newsletter"
                      >Himachal</a
                    >
                    <a @click="domestic()" class="d-block text-dark footer__link  footer__newsletter"
                      >Sikkim</a
                    >
                    <a @click="domestic()" class="d-block text-dark footer__link  footer__newsletter"
                      >Uttarakhand</a
                    >
                    <a @click="domestic()" class="d-block text-dark footer__link  footer__newsletter"
                      >Rajasthan</a
                    >
                    <a @click="domestic()" class="d-block text-dark footer__link  footer__newsletter"
                      >Arunachal</a
                    >
                    <a @click="domestic()" class="d-block text-dark footer__link  footer__newsletter"
                      >Ladakh</a
                    >
                    <a @click="domestic()" class="d-block text-dark footer__link  footer__newsletter"
                      >Gujarat</a
                    >
                    <a @click="domestic()" class="d-block text-dark footer__link  footer__newsletter"
                      >Tamil Nadu</a>
                      <a @click="domestic()" class="d-block text-dark footer__link  footer__newsletter"
                      >Kerala</a>
                      <a @click="domestic()" class="d-block text-dark footer__link  footer__newsletter"
                      >Goa</a>
                      <a @click="domestic()" class="d-block text-dark footer__link  footer__newsletter"
                      >Andhra Pradesh</a>
                  </nav>
                </div>

                <div class="col-sm-12 col-lg-3 mb-5 mb-lg-0">
                  <h5 class="footer__header mb-4" style="text-transform: uppercase;">
                    international
                  </h5>
                  <nav class="d-inline-block">
                    <a @click="international()" class="d-block text-dark footer__link  footer__newsletter"
                      >Singapore-Malaysia</a
                    >
                    <a @click="international()" class="d-block text-dark footer__link  footer__newsletter"
                      >Dubai</a
                    >
                    <a @click="international()" class="d-block text-dark footer__link  footer__newsletter"
                      >Thailand</a
                    >
                    <a @click="international()" class="d-block text-dark footer__link  footer__newsletter"
                      >Vietnam</a
                    >
                    <a @click="international()" class="d-block text-dark footer__link  footer__newsletter"
                      >Srilanka</a
                    >
                    <a @click="international()" class="d-block text-dark footer__link  footer__newsletter"
                      >Bangladesh</a
                    >
                  </nav>
                </div>
                <div class="col-sm-12 col-lg-3 mb-5 mb-lg-0">
                  <h5 class="footer__header mb-4">TOUR THEMES</h5>
                  <nav class="d-inline-block">
                    <a href="#" class="d-block text-dark footer__link  footer__newsletter"
                      >Hill Stations</a
                    >
                    <a href="#" class="d-block text-dark footer__link  footer__newsletter"
                      >Heritage</a
                    >
                    <a href="#" class="d-block text-dark footer__link  footer__newsletter">Beach</a>
                    <a href="#" class="d-block text-dark footer__link  footer__newsletter"
                      >Trekking</a
                    >
                    <a href="#" class="d-block text-dark footer__link  footer__newsletter"
                      >Pilgrimage</a
                    >
                    <a href="#" class="d-block text-dark footer__link  footer__newsletter"
                      >Wild Life</a
                    >
                    <a href="#" class="d-block text-dark footer__link  footer__newsletter"
                      >Adventure</a
                    >
                  </nav>
                </div>
              </div>
            </div>
            <!-- <div class="col-sm-12 col-lg-1"></div> -->
          </div>
        </div>
      </div>

      <div class="black--text">
        <v-card-title>
          © {{ new Date().getFullYear() }}, Majumder Special. All rights reserved.
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          Develop & Maintained by &nbsp;
          <a href="http://infosyst.in/" target="_blank">Infosyst</a>
        </v-card-title>
        <!-- <div> <img src="../../assets/logo.png" width="300px"></div> -->
      </div>
    </footer>
  </v-app>
</template>

<script>
import Avatar from "vue-avatar";
import config from "./../../config.json";
//import vuetifyToast from "vuetify-toast";
//import { AuthStr } from "../Auth.js";
/* import carousel from 'vue-owl-carousel'; */
const DEFAULT_TRANSITION = "fade";
export default {
  components: {
    Avatar
  },
  data() {
    return {
      valid: true,
      passwordShow: false,
      activeItem: 'Home',
      menu: false,
      darkMode: false,
      dateModel: false,
      enquiryDialog: false,
      logOutDialog: false,
      loggedInUserName: sessionStorage.loggedInUserName,
      loggedInUserID: sessionStorage.loggedInUserID,
      role: sessionStorage.roles,
      transitionName: DEFAULT_TRANSITION,
      isLoading: false,
      destinations: null,
      selectedDestination: null,
      btnSave: false,
      src: "https://aimroindia.com/aimro/api/ProfilePic/" + sessionStorage.loggedInUserID,

      bookDialog: false,
      bookForm: {
        email: null,
        tourName: null,
        travelDate: null,
        agree: false,
        up: null,
        dn: null,
        officeAddress: null,
        officePhno: null,
        residentialAddress: null,
        residentialPhno: null
      },

      nameList: [
        {
          name: "",
          sex: "",
          age: ""
        },
        {
          name: "",
          sex: "",
          age: ""
        },
        {
          name: "",
          sex: "",
          age: ""
        },
        {
          name: "",
          sex: "",
          age: ""
        },
        {
          name: "",
          sex: "",
          age: ""
        },
        {
          name: "",
          sex: "",
          age: ""
        },
        {
          name: "",
          sex: "",
          age: ""
        },
        {
          name: "",
          sex: "",
          age: ""
        }
      ],
      selected: '',
      options: [
        { text: 'M', value: 'M' },
        { text: 'F', value: 'F' },
        { text: 'O', value: 'O' }
      ],

      rules: {
        required: value => !!value || "Required.",
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
        emailid: value => {
          const pattern = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          return pattern.test(value) || "Email Id is not valid!!";
        }
      },

      form: {
        email: null,
        mobileNumber: null,
        destination: null,
        startingFrom: null,
        startDate: null,
        budget: null,
        adult: 1,
        children: 0,
        notes: null,
        need: false
      },

      durations: [
        "2 Days & 1 Night",
        "3 Days & 2 Nights",
        "4 Days & 3 Nights",
        "5 Days & 4 Nights",
        "6 Days & 5 Nights",
        "7 Days & 6 Nights",
        "8 Days & 7 Nights",
        "9 Days & 8 Nights",
        "10 Days & 9 Nights",
        "More Than 10 Days"
      ],
      selectedDuration: null,

      transportations: [
        "Standard Vehicle",
        "Hatchback (4 Pax)",
        "Sedan (4 Pax)",
        "SUV (7 Pax)",
        "Luxury Car (4/7 Pax)",
        "Tempo (12-15 Pax)",
        "Small Coach (20 Pax)",
        "Coach (25-30 Pax)",
        "Mini Bus (35-40 Pax)",
        "Bus (50 Pax)",
        "Other (Provide Notes)"
      ],
      selectedTransportation: null,

      accommodations: [
        "Budget Accommodation",
        "2-star Accommodation",
        "3-Star Accommodation",
        "4-Star Accommodation",
        "3-Star & Above"
      ],
      selectedAccommodation: null
    };
  },
  methods: {
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    setActiveItem(item) {
        this.activeItem = item;
        if(item === 'Home') this.main();
        else if(item === 'About us') this.aboutUs();
        else if(item === 'Services') this.services();
        else if(item === 'Gallery') this.gallery();
        else if(item === 'Domestic') this.destination();
        else if(item === 'International') this.destination1();
        else if(item === 'Rules') this.termsUse();
    },

    getData() {
      this.axios
        .get(config.API + "Admin/" + sessionStorage.loggedInUserID, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.src = res.data.src;
          this.$Progress.finish();
          this.getData();
        });
    },

    logOut() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/main");
        window.location.reload();
      });
    },

    domestic() {
      this.$router.push("/destinationmenu");
    },

    international() {
      this.$router.push("/destinationInter");
    },

    dashboard() {
      this.$router.push("/_");
    },

    changePassword() {
      this.$router.push(`changePassword/` + this.loggedInUserID);
    },
    editProfile() {
      if (sessionStorage.roles === "Member") {
        this.$router.push(`memberEditProfile/` + this.loggedInUserID);
      }
      if (sessionStorage.roles === "StockPoint Administrator") {
        this.$router.push(`stockpointEditProfile/` + this.loggedInUserID);
      }
      this.menu = false;
    },

    contactus() {
      this.$router.push(`/contactUs`);
    },
    aboutUs() {
      this.$router.push(`/aboutUs`);
    },
    management() {
      this.$router.push(`/management`);
    },
    paymentSecurity() {
      this.$router.push(`/paymentSecurity`);
    },
    privacyPolicy() {
      this.$router.push(`/privacyPolicy`);
    },
    termsUse() {
      this.$router.push(`/termsUse`);
    },
    main() {
      this.$router.push(`/main`);
    },
    services() {
      this.$router.push(`/services`);
    },

    go() {
      this.$router.push("/main");
      window.location.reload();
    },

    destination() {
      this.$router.push("/destinationmenu");
    },
    destination1() {
      this.$router.push("/destinationInter");
    },

    blog() {
      this.$router.push("/blogPage");
    },
    gallery() {
      this.$router.push("/gallery");
    },
    packages() {
      this.$router.push("/packages");
    },
    facebook() {
      let url = "https://www.facebook.com/people/Majumder-Special/100064500534586/?mibextid=kFxxJD";
      window.open(url, "_blank");
    },

    instagram() {
      let url = "https://www.instagram.com/wanderlusters123/";
      window.open(url, "_blank");
    },

    login() {
      this.$router.push("/login");
    },
    home() {
      sessionStorage.removeItem("course");
      sessionStorage.removeItem("level");
      sessionStorage.removeItem("country");
      this.$router.push("/main");
    },
    loginPage() {
      this.$router.push("/login");
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `Enquiries`,
            {
              email: this.form.email,
              mobileNumber: this.form.mobileNumber,
              destination: this.form.destination,
              startingFrom: this.form.startingFrom,
              startDate: this.form.startDate,
              duration: this.selectedDuration,
              budget: this.form.budget,
              adult: this.form.adult,
              children: this.form.children,
              transportation: this.selectedTransportation,
              accommodation: this.selectedAccommodation,
              notes: this.form.notes,
              need: this.form.need
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Your Enquiry has been Successfully send");
            this.enquiryDialog = false;
            this.btnSave = false;
            this.$refs.form.reset();
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    onAdd() {
      this.nameList.push({
        name: "",
        sex: "",
        age: ""
      })
    },

    onBook() {
      console.log(this.nameList[0].name);
      if(this.bookForm.email!=null&&this.bookForm.email!='') {
        if(this.nameList[0].name==''||this.nameList[0].sex==''||this.nameList[0].age=='') {
        this.$toaster.error("First row should be filled up");
      }
      else {
        this.btnSave = true;
        console.log({
          email: this.bookForm.email,
          tourName: this.bookForm.tourName,
          travelDate: this.bookForm.travelDate,
          up: this.bookForm.up,
          dn: this.bookForm.dn,
          officeAddress: this.bookForm.officeAddress,
          officePhno: this.bookForm.officePhno,
          residentialAddress: this.bookForm.residentialAddress,
          residentialPhno: this.bookForm.residentialPhno,
          name: this.nameList[0].name,
          sex: this.nameList[0].sex,
          age: this.nameList[0].age,
          bookDetails: this.nameList
        });
        this.axios
          .post(
            config.API + `Book`,
            {
              email: this.bookForm.email,
              tourName: this.bookForm.tourName,
              travelDate: this.bookForm.travelDate,
              up: this.bookForm.up,
              dn: this.bookForm.dn,
              officeAddress: this.bookForm.officeAddress,
              officePhno: this.bookForm.officePhno,
              residentialAddress: this.bookForm.residentialAddress,
              residentialPhno: this.bookForm.residentialPhno,
              name: this.nameList[0].name,
              sex: this.nameList[0].sex,
              age: this.nameList[0].age,
              bookDetails: this.nameList
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully booked");
            this.bookDialog = false;
            this.btnSave = false;
            //this.$refs.bookForm.reset();
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      }
      }
      else {
        this.$toaster.error("Email is required");
      }
    }
  },

  mounted() {
    //this.getData();
    this.axios
      .get(config.API + "Destinations1", {
        headers: {
          Authorization: "bearer " + sessionStorage.getItem("token")
        }
      })
      .then(res => {
        this.destinations = res.data;
        this.$Progress.finish();
      });
    this.$Progress.start();
  },

  created() {
    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName;
      if (transitionName === "slide") {
        const toDepth = to.path.split("/").length;
        const fromDepth = from.path.split("/").length;
        transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
      }
      this.transitionName = transitionName || DEFAULT_TRANSITION;
      next();
    });

    this.getData();
  }
};
</script>

<style scoped>
@import "../../HomeCss/home.css";
@import url("https://fonts.googleapis.com/css?family=Farro&display=swap");
@keyframes blink {
  from {
    background-color: purple;
  }
  to {
    background-color: red;
  }
}
.active {
    color: red !important; /* Change this to your desired color */
}
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}
.header-menu .nav-item {
  margin-top: -10px !important;
  font-size: 16px;
  text-align: center;
}
.nav-link {
  color: #000 !important;
}
.nav-link:hover {
  color: #c00c0c !important;
}
.btn {
  font-size: 20px;
}
.txt_my {
  font-family: "Alice", serif !important;
}
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}
.mybg {
  background-color: #FFFFFF !important;
}
.header-top {
  background-color: #FAF8ED !important;
  color: black;
  width: 100%;
  padding: 6px;
  /* margin-bottom: 5px; */
}

.mycontainer {
  padding-left: 15px;
  padding-right: 15px;
}
.header-top img {
  height: 30px;
  margin-right: 10px;
}
.bgclr {
  width: 100%;
  height: 350px;
  background-image: linear-gradient(#7b1fa2, #e91e63);
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.ss {
  border-radius: 5%;
  height: 60px !important;
}
.ss1 {
  border-radius: 5%;
  height: 58px !important;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.near {
  top: -70px;
  position: relative;
}
.near1 {
  top: -70px;
  bottom: -30px;
  position: relative;
}
.txtcntr {
  text-align: center;
}
.mrgn {
  margin-top: 70px;
}
.pdng {
  padding-bottom: -25px !important;
}
h1.heading_1 {
  width: 100% !important;
}

.bg_clr {
  background-color: grey;
}

.heading_1 {
  font-family: "Space Mono", monospace;
  text-align: center !important;
}
.main_icon {
  text-align: center !important;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.hotel_name {
  font-family: "Space Mono", monospace;
  font-weight: bold;
}
.hotel_name1 {
  font-family: "Anton", sans-serif;
}
.v-table tbody tr:not(:last-child) {
  border-bottom: none !important;
}
.theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
  /* background: #fff !important;
  border-bottom: none !important; */
}
.footer-info-box {
  margin-top: 30px;
}
.footer-info-box p {
  margin-bottom: 5px;
}
td.hvr:hover {
  background-color: #fff !important;
  background: #fff !important;
  border-bottom: none !important;
}
.socials {
  margin-top: 15px;
  display: flex;
  /* justify-content: space-around; */
}
.socials .icon img {
  height: 40px;
  width: 40px;
  padding: 5px;
  border-radius: 50%;
  /* background-color: #E4573D ; */
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}
.socials .icon img:hover {
  transform: scale(1.2);
}
.rate {
  height: 280px;
  border-radius: 4%;
  background-image: linear-gradient(#7b1fa2, #e91e63);
  /* background-color: #eeeeee; */
}
.yellowText {
  color: yellow;
}
.font12 {
  font-size: 12px;
  line-height: 12px;
}
.latoBold {
  font-weight: 700;
}
.sprite.discountIcon {
  width: 38px;
  height: 17px;
  background-position: -206px -73px;
}
.appendLeft5 {
  margin-left: 5px;
}
.sprite {
  background: url(//imgak.mmtcdn.com/pwa_v3/pwa_hotel_assets/web/hotelSprite-v4.png) no-repeat;
  display: inline-block;
  background-size: 400px 400px;
  font-size: 0px;
  flex-shrink: 0;
}
.font11 {
  font-size: 11px;
  line-height: 11px;
}
.discountText {
  display: inline-block;
  position: absolute;
  left: 12px;
  top: 2px;
}
.lineThrough {
  text-decoration: line-through;
}
.filtr {
  background-image: linear-gradient(#e91e63, #7b1fa2);
}
.aminity {
  width: 100%;
}
.aminities {
  width: 30%;
  float: left;
}
.v-sheet--offset {
  top: -50px;
  position: relative;
}
.sign {
  color: white !important;
}
tr {
  border-bottom: none !important;
}
.form-container {
  margin: 0px !important;
}
.flashing_effect {
  background-image: linear-gradient(-90deg, #f44336, #b32e25);
  padding: 12px 15px;
  animation-name: flashing;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
@keyframes flashing {
  0% {
    opacity: 1;
  }
  25% {
    opacity: 0.6;
  }
  50% {
    opacity: 0.3;
  }
  75% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}
@media screen and (max-width: 768px) {
  .heading_1 {
    font-size: 14px;
  }
  .rspnsv {
    margin-bottom: 30px;
    height: auto;
  }
  ._hello {
    height: auto !important;
  }
  .res {
    display: none;
  }
  .header-top img {
    height: 20px;
    margin-right: 10px;
  }
  .navbar {
    justify-content: space-around !important;
  }
}
@media screen and (min-width: 768px) {
  .man {
    display: none;
  }
}
.abc {
  overflow: hidden !important;
}
</style>
